import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

import type { FC, ReactNode } from 'react';

type InfoListItem = {
  key: string;
  value: ReactNode;
};

type InfoListProps = {
  items: InfoListItem[];
  className?: string;
};

const InfoList: FC<InfoListProps> = ({ items, className }) => (
  <dl
    className={twMerge(
      'grid grid-cols-2 gap-2 text-lg text-marine-high-emphasis hyphens-auto break-words',
      className,
    )}
  >
    {items.map(({ key: term, value }, i) => (
      <Fragment key={`InfoList_${i}`}>
        <dt className="min-w-0 font-semibold">{term}</dt>
        <dd className="m-0 min-w-0">{value}</dd>
      </Fragment>
    ))}
  </dl>
);

export { InfoList, type InfoListProps, type InfoListItem };
